import { combineReducers } from 'redux'
import authCombinedReducer from './auth'

import employeeReducer from '@/features/payroll/employee.slice'
import employeeJobReducer from '@/features/payroll/employeeJob.slice'
import payrollPriceReducer from '@/features/payroll/payrollPrice.slice'
import payrollProfileReducer from '@/features/payroll/payrollProfile.slice'
import payScheduleReducer from '@/features/payroll/paySchedule.slice'
import transactionCategoriesReducer from '@/features/reports/reports.slice'
import merchantReviewReducer from '@/features/adviser-chat/merchantReview.slice'
import financialAccountsReducer from './finances/financialAccountsReducer'
import financialInsightsReducer from './finances/financialInsightsReducer'
import transactionFiltersReducer from './finances/transactionFiltersReducer'
import userDocumentsReducer from '@/features/user/your-practice/documents/lib/userDocuments.slice'
import userCallEventsReducer from './finances/userCallEventsReducer'
import bookkeepingReportsReducer from './finances/bookkeepingReportsReducer'
import userTaxEstimatesReducer from '@/features/taxes/quarterly/userTaxEstimates.slice'
import safeHarborCatchUpReducer from '@/features/taxes/quarterly/safeHarborCatchUp.slice'
import allocationGuidesReducer from './finances/allocationGuidesReducer'
import allocationRulesReducer from './finances/allocationRulesReducer'
import financialProfileActionItemsReducer from '@/features/user/dashboard/financialProfileActionItems.slice'
import annualTaxFilingsReducer from '@/features/taxes/annual-taxes/annualTaxFilings.slice'
import annualTaxFilingFormsReducer from '@/features/taxes/annual-taxes/annualTaxFilingForms.slice'
import annualTaxFormTypesReducer from '@/features/taxes/annual-taxes/annualTaxFormType.slice'
import transactionsReducer from '@/features/transactions/transactions.slice'
import annualTaxOutcomeReducer from '@/features/taxes/annual-taxes/annualTaxOutcome.slice'
import adminReducer from './admin'
import fetchReducer from './fetch'
import conversationsReducer from '@/components/conversations/conversation.slice'
import calendlyLinkReducer from './calendlyLink.slice'
import chartOfAccountsReducer from '@/components/ChartOfAccounts/chartOfAccount.slice'
import contractorReducer from '@/features/payroll/contractor.slice'
import payrollCompanyReducer from '@/features/payroll/payrollCompany.slice'
import payrollCompanyLocationReducer from '@/features/payroll/payrollCompanyLocation.slice'
import payrollReducer from '@/features/payroll/payroll.slice'
import userTaxCalculationsReducer from '@/features/admin/user-tax-calculations/userTaxCalculation.slice'
import quarterlyTaxEstimateDetailsReducer from '@/features/admin/quarterly-tax-estimate-details/quarterlyTaxEstimateDetails.slice'
import annualTaxDetailsReducer from '@/features/admin/annual-tax-details/annualTaxDetails.slice'
import subscriptionReducer from './subscription.slice'
import userImportantDatesReducer from '@/features/user/dashboard/user-important-dates/userImportantDates.slice'
import userActionItemsReducer from '@/features/user/dashboard/user-action-items/lib/userActionItems.slice'
import sidebarReducer from './sidebar.slice'
import allEoyReviewStepsReducer from '@/features/taxes/annual-taxes/tax-checklist/shared/review-steps-and-progresses/allEoyReviewSteps.slice'
import userEoyReviewProgressReducer from '@/features/taxes/annual-taxes/tax-checklist/shared/review-steps-and-progresses/userEndOfYearReviewProgress.slice'
import flyoutReducer from './flyout.slice'
import plaidItemReducer from './finances/plaidItemReducer'
import plaidLauncherReducer from './finances/plaidLauncherReducer'
import journalEntryReducer from './admin/journalEntryReducer'
import taxChecklistQuestionReducer from '@/features/taxes/annual-taxes/tax-checklist/taxChecklistQuestion.slice'
import sCorpStatusReducer from '@/features/user/dashboard/s-corp-upsell/sCorpStatus.slice'
import journalEntryLineReducer from './admin/journalEntryLineReducer'
import smsConsentReducer from '@/features/user/settings/sections/account-details-card/sms-consent/smsConsentReducer'
import taxUserDocumentsReducer from '@/features/taxes/annual-taxes/taxUserDocuments.slice'
import plaidStatementInstitutionsReducers from './finances/plaidStatementInstitutionsReducers'
import financialAdvisoryProfileReducer from '@/features/financial-advisory/financialAdvisory.slice'
import userFinancialAdvisoryCallEventsReducer from '@/features/financial-advisory/userFinancialAdvisoryCallEvents.slice'
import catchUpBookkeepingStatusReducer from '@/components/CatchUpBookkeepingStatus/catchUpBookkeepingStatus.slice'
import cubkProgressReducer from '@/features/user/dashboard/onboarding/catch-up-bookkeeping/lib/cubkProgress.slice'
import onboardingReducer from '@/features/onboarding/user-onboarding-steps/onboarding.reducer'
import providerReducer from '@/features/provider/provider.reducer'
import yearEndModuleStatusReducer from '@/features/year-end-module-status/yearEndModuleStatus.slice'
import userCouponsReducer from '@/features/user-coupons/userCoupons.slice'
import insightsReducer from './insights.slice'
import incomePlanningReducer from '@/features/income-planning/incomePlanning.slice'
import documentUploadReducer from '@/features/bookkeeping/services/documentUpload.slice'
import bankingReducer from '@/features/banking/bankingSlice'
import adminBankingProfileReducer from '@/features/admin/user-record/adminBankingProfileSlice'
import adviserChatReducer from '@/features/adviser-chat/adviser-chat.slice'
import complianceReducer from '@/features/compliance/compliance.slice'
import separationReducer from '@/features/onboarding/separation/separation.slice'
import planChangeReducer from '@/features/user/settings/sections/plan-change/lib/planChange.slice'

export default combineReducers({
  admin: adminReducer,
  adminBankingProfile: adminBankingProfileReducer,
  adviserChat: adviserChatReducer,
  allEoyReviewSteps: allEoyReviewStepsReducer,
  allocationGuides: allocationGuidesReducer,
  allocationRules: allocationRulesReducer,
  annualTaxDetails: annualTaxDetailsReducer,
  annualTaxFilings: annualTaxFilingsReducer,
  annualTaxFilingForms: annualTaxFilingFormsReducer,
  annualTaxOutcomes: annualTaxOutcomeReducer,
  annualTaxFormTypes: annualTaxFormTypesReducer,
  auth: authCombinedReducer,
  banking: bankingReducer,
  bookkeepingReports: bookkeepingReportsReducer,
  calendlyLinks: calendlyLinkReducer,
  catchUpBookkeepingStatus: catchUpBookkeepingStatusReducer,
  cubkProgress: cubkProgressReducer,
  chartOfAccounts: chartOfAccountsReducer,
  compliance: complianceReducer,
  separation: separationReducer,
  contractors: contractorReducer,
  conversations: conversationsReducer,
  documentUpload: documentUploadReducer,
  fetch: fetchReducer,
  flyout: flyoutReducer,
  financialAccounts: financialAccountsReducer,
  financialInsights: financialInsightsReducer,
  financialProfileActionItems: financialProfileActionItemsReducer,
  financialAdvisoryProfile: financialAdvisoryProfileReducer,
  employees: employeeReducer,
  employeeJobs: employeeJobReducer,
  journalEntryLines: journalEntryLineReducer,
  journalEntries: journalEntryReducer,
  incomePlanning: incomePlanningReducer,
  insights: insightsReducer,
  onboarding: onboardingReducer,
  payrolls: payrollReducer,
  payrollPrice: payrollPriceReducer,
  payrollProfile: payrollProfileReducer,
  paySchedule: payScheduleReducer,
  payrollCompany: payrollCompanyReducer,
  payrollCompanyLocation: payrollCompanyLocationReducer,
  plaidItems: plaidItemReducer,
  plaidLauncher: plaidLauncherReducer,
  plaidStatementInstitutions: plaidStatementInstitutionsReducers,
  planChange: planChangeReducer,
  providers: providerReducer,
  quarterlyTaxEstimateDetails: quarterlyTaxEstimateDetailsReducer,
  sCorpStatus: sCorpStatusReducer,
  sidebarState: sidebarReducer,
  smsConsentStatuses: smsConsentReducer,
  subscription: subscriptionReducer,
  taxChecklist: taxChecklistQuestionReducer,
  taxUserDocuments: taxUserDocumentsReducer,
  transactions: transactionsReducer,
  transactionCategories: transactionCategoriesReducer,
  merchantReview: merchantReviewReducer,
  transactionFilters: transactionFiltersReducer,
  userActionItems: userActionItemsReducer,
  userCallEvents: userCallEventsReducer,
  userCoupons: userCouponsReducer,
  userDocuments: userDocumentsReducer,
  userEoyReviewProgress: userEoyReviewProgressReducer,
  userFinancialAdvisoryCallEvents: userFinancialAdvisoryCallEventsReducer,
  userImportantDates: userImportantDatesReducer,
  userTaxCalculations: userTaxCalculationsReducer,
  safeHarborCatchUp: safeHarborCatchUpReducer,
  userTaxEstimates: userTaxEstimatesReducer,
  yearEndModuleStatuses: yearEndModuleStatusReducer,
})
